import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b271a344"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "suggestions-datails-group" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-12" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", { class: "solid" }, null, -1));
const _hoisted_5 = { class: "row" };
const _hoisted_6 = { class: "col-5" };
const _hoisted_7 = { class: "col-7" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", { class: "solid my-4" }, null, -1));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", { class: "solid my-4" }, null, -1));
const _hoisted_10 = { class: "row" };
const _hoisted_11 = { class: "col-12" };
const _hoisted_12 = {
    key: 2,
    class: "solid my-4"
};
const _hoisted_13 = {
    key: 3,
    class: "row"
};
const _hoisted_14 = { class: "col-12" };
const _hoisted_15 = { class: "submit" };
const _hoisted_16 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_campaigns_management_type = _resolveComponent("campaigns-management-type");
    const _component_campaigns_management_details_header = _resolveComponent("campaigns-management-details-header");
    const _component_campaigns_management_details_period = _resolveComponent("campaigns-management-details-period");
    const _component_campaigns_management_details_dates = _resolveComponent("campaigns-management-details-dates");
    const _component_campaigns_management_send_limit = _resolveComponent("campaigns-management-send-limit");
    const _component_campaigns_management_details_quarantine = _resolveComponent("campaigns-management-details-quarantine");
    const _component_campaigns_management_distribution_rule = _resolveComponent("campaigns-management-distribution-rule");
    const _component_campaigns_management_details_messages = _resolveComponent("campaigns-management-details-messages");
    const _component_campaigns_management_details_campaigns = _resolveComponent("campaigns-management-details-campaigns");
    const _component_campaigns_management_detail_campaigns_modal = _resolveComponent("campaigns-management-detail-campaigns-modal");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            (_ctx.getEnableAutomaticAction)
                ? (_openBlock(), _createBlock(_component_campaigns_management_type, { key: 0 }))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_campaigns_management_details_header, { onVisibleChange: _ctx.handleDropdownVisibleState }, null, 8, ["onVisibleChange"])
            ])
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_campaigns_management_details_period)
            ]),
            _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_campaigns_management_details_dates)
            ])
        ]),
        (_ctx.automaticAction.sendChannel === _ctx.channel.NON_OFFICIAL)
            ? (_openBlock(), _createBlock(_component_campaigns_management_send_limit, { key: 0 }))
            : _createCommentVNode("", true),
        _hoisted_8,
        _createVNode(_component_campaigns_management_details_quarantine),
        (_ctx.automaticAction.sendChannel === _ctx.channel.NON_OFFICIAL)
            ? (_openBlock(), _createBlock(_component_campaigns_management_distribution_rule, { key: 1 }))
            : _createCommentVNode("", true),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
                (_ctx.automaticAction.sendChannel === _ctx.channel.NON_OFFICIAL || _ctx.actionTemplates.length)
                    ? (_openBlock(), _createBlock(_component_campaigns_management_details_messages, {
                        key: 0,
                        "is-automatic-action": true
                    }))
                    : _createCommentVNode("", true)
            ])
        ]),
        (_ctx.actionTemplates.length)
            ? (_openBlock(), _createElementBlock("hr", _hoisted_12))
            : _createCommentVNode("", true),
        (_ctx.automaticAction.sendChannel === _ctx.channel.SELLER)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_campaigns_management_details_campaigns)
                ])
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
                disabled: _ctx.isSubmitDisabled,
                class: "btn",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
            }, _toDisplayString(_ctx.submitText), 9, _hoisted_16)
        ]),
        _createVNode(_component_campaigns_management_detail_campaigns_modal)
    ]));
}
